/**
 * Public itinerary preview — Phase 5 navbar-leak fix (Feb 2026).
 *
 * Mounted at `/itinerary-preview/:id` OUTSIDE the protected <Layout> in
 * App.js, so the CRM navbar / sidebar do NOT render into the Playwright-
 * generated PDF. The body renders the existing ItineraryPreview component
 * with `printMode={true}`, which hides only the 4-button action bar
 * (Back / Internal-View / WhatsApp / Download PDF). All voucher-bound
 * content (cover, day cards, hotel cards, pricing, footer) is unchanged.
 *
 * Auth: the underlying ItineraryPreview component still hits the
 * protected `/api/itineraries/{id}` endpoint. The generatePDF() util
 * forwards httpOnly cookies + the localStorage Bearer token to
 * `/api/pdf/render`, which the headless Chromium replays before
 * navigating here — same pattern proven by the voucher migration.
 *
 * This route is intentionally NOT linked from any nav/menu. It exists
 * solely for the Playwright PDF render of an itinerary.
 *
 * Phase B2 FEATURE 3 — reads `?showPrice=true|false` query param from
 * the URL the generatePDF() call constructs, forwards it to the preview
 * component so price blocks render or hide accordingly. Defaults to
 * `true` (show price) when the param is missing or any non-`false`
 * value, matching the protected-route default state.
 */
import React, { useEffect } from 'react';
import ItineraryPreview from './ItineraryPreview';

export default function PublicItinerary() {
  const showPrice =
    new URLSearchParams(window.location.search).get('showPrice') !== 'false';

  // Opt this public/Playwright route out of the global @media print
  // visibility:hidden rule in index.css. Without this, page.pdf() blanks
  // the body and only the Playwright header/footer template survives.
  useEffect(() => {
    document.body.classList.add('pdf-public-route');
    return () => document.body.classList.remove('pdf-public-route');
  }, []);

  return <ItineraryPreview printMode showPriceProp={showPrice} />;
}
